<template>
  <div class="admin" onsroll="onScroll">
    <div v-if="submissions.pending == undefined">
      <h1>Admin</h1>

      <span>User/Password</span>:
      <br />
      <br />
      <input id="userName" v-on:keyup.enter="logIn()" type="text" v-model="userName" />
      <br />
      <br />
      <input id="pass" v-on:keyup.enter="logIn()" type="password" v-model="password" />
      <br />
      <br />
      <button @click="logIn()">OK</button>
      <br />
      <br />
      <span class="error">{{error}}</span>
      <span id="capLock" v-if="capLockOn" class="error">WARNING! Caps lock is ON.</span>
    </div>
    <div v-else>
      <adminPopup
        v-if="showModal"
        :submission="selectedSubmission"
        @save="reload"
        @cancel="showModal=false"
      />
      <h1>Admin</h1>
      <ul class="tabs">
        <li @click="selectTab('pending')" :class="{'active': selectedTab == 'pending'}">Pending</li>
        <li @click="selectTab('rejected')" :class="{'active': selectedTab == 'rejected'}">Rejected</li>
        <li @click="selectTab('approved')" :class="{'active': selectedTab == 'approved'}">Approved</li>
        <li
          v-if="admin == 1"
          @click="selectTab('users')"
          :class="{'active': selectedTab == 'users'}"
        >Users</li>
      </ul>
      <table v-if="selectedTab != 'users'">
        <thead>
          <tr>
            <th>Date submitted</th>
            <th>Image</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Picture Location</th>
            <th>City</th>
            <th>Country</th>
            <th>Subscriber Key</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(submission, index) in submissions[selectedTab].submissions">
            <td @click="selectSubmissionToEdit(submission)">{{submission.dateInserted}}</td>
            <td>
              <img
                v-if="submission.userImage != ''"
                @click="selectSubmissionToEdit(submission)"
                :src="'https://app.brighton.com/brighton-your-day/tmp/'+ '214_' + submission.userImage+'?'+Math.random()"
              />
              <a
              v-if="submission.userImage != ''"
                target="_new"
                download
                :href="'https://app.brighton.com/brighton-your-day/tmp/'+ submission.userImage+'?'+Math.random()"
              >Download</a>
              <i style="color: red; font-size: 20px" v-else class="fa fa-file-image-o" aria-hidden="true"></i>
            </td>
            <!-- <td><img @click="selectSubmissionToEdit(submission)" :src="'https://app.brighton.com/summer-of-joy-at-brighton/tmp/'+ (submission.approved == '0' ? '' : '214_') + submission.userImage+'?'+Math.random()"/><a target="_new" download :href="'https://app.brighton.com/summer-of-joy-at-brighton/tmp/'+ submission.userImage+'?'+Math.random()">Download</a></td> -->
            <td @click="selectSubmissionToEdit(submission)">{{submission.firstName}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.lastName}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.email}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.phone}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.pictureLocation}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.city}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.country}}</td>
            <td @click="selectSubmissionToEdit(submission)">{{submission.subscriberKey}}</td>
          </tr>
          <tr class="pagination">
            <td colspan="10">
              <div>
                <!--    <select name="" id="" @change="getPage()">
                  <option @click="getPage(n-1)" v-for=" n in Math.round(parseInt(submissions[selectedTab].numRows) / numPerPage) + 1">{{n}} </option>
                </select>-->
                <span
                  @click="getPage(n-1)"
                  v-for=" n in Math.round(parseInt(submissions[selectedTab].numRows) / numPerPage) + 1"
                >{{n}}</span>
              </div>
              Total records: {{ submissions[selectedTab].numRows}}
            </td>
          </tr>
        </tbody>
      </table>
      <table v-else>
        <thead>
          <tr>
            <th>user</th>
            <th>password</th>
            <th>active</th>
            <th>admin</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in usersTemp">
            <td>
              <input type="text" v-model="user.email" />
            </td>
            <td>
              <input type="text" v-model="user.password" />
            </td>
            <td>
              <input type="checkbox" v-model="user.active" true-value="1" false-value="0" />
            </td>
            <td>
              <input type="checkbox" v-model="user.admin" true-value="1" false-value="0" />
            </td>
            <td>
              <button @click="removeUser(user)">REMOVE</button>
            </td>
          </tr>
          <tr bgcolor="#ebebeb">
            <td>
              <input type="text" v-model="newUser.email" />
            </td>
            <td>
              <input type="text" v-model="newUser.password" />
            </td>
            <td>
              <input type="checkbox" v-model="newUser.active" true-value="1" false-value="0" />
            </td>
            <td>
              <input type="checkbox" v-model="newUser.admin" true-value="1" false-value="0" />
            </td>
            <td>New User</td>
          </tr>
          <tr>
            <td colspan="5">
              <button @click="saveUsers()">Save</button>
              <br />
              <br />
              <span v-if="userUpdateMsg != ''">{{userUpdateMsg}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="bottom"></div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import adminPopup from "@/components/adminPopup";
export default {
  name: "admin",
  props: {
    msg: String
  },
  components: { adminPopup },
  data() {
    return {
      numPerPage: 25,
      error: "",
      showModal: false,
      password: "",
      userName: "",
      selectedTab: "pending",
      selectedSubmission: null,
      submissions: {},
      capLockOn: false,
      admin: null,
      users: [],
      usersTemp: [],
      userUpdateMsg: "",
      newUser: {
        active: 0,
        email: "",
        password: "",
        admin: 0
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", function() {
      // window.lastScrollTime = new Date().getTime()
      // console.log(window.scrollTop)
      // var objDiv = document.getElementById("bottom");
      // console.log(objDiv.scrollHeight, objDiv.scrollTop )
    });

    // window.onsroll(()=>{
    //   console.log(document.body.scrollTop)
    // })
  },
  watch: {},
  methods: {
    onScroll() {
      console.log(document.body.scrollTop);
    },
    async getPage(pageNum) {
      let status =
        this.selectedTab == "pending"
          ? 0
          : this.selectedTab == "rejected"
          ? -1
          : 1;
      this.getAllSubmissions(status, pageNum);
    },
    async removeUser(user) {
      if (!confirm(`Removing user ${user.email}?`)) return false;

      var formData = new FormData();
      this.userUpdateMsg = "Removing...";
      formData.append("userName", this.userName);
      formData.append("password", this.password);
      formData.append("userID", user.id);
      let returnedData = await axios({
        method: "POST",
        url: `https://app.brighton.com/brighton-your-day/api/admin/removeUser`,
        responseType: "json",
        data: formData,
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      });
      if (returnedData.data.success) {
        this.userUpdateMsg = "Updated";
        this.users = JSON.parse(JSON.stringify(returnedData.data.users));
        this.usersTemp = JSON.parse(JSON.stringify(returnedData.data.users));
      } else this.userUpdateMsg = "Update failed";
    },
    async saveUsers() {
      var formData = new FormData();
      this.userUpdateMsg = "Saving...";
      formData.append("userName", this.userName);
      formData.append("password", this.password);
      let updateUsers = this.usersTemp.filter((user, index) => {
        return (
          index >= this.users.length ||
          user.email != this.users[index].email ||
          user.password != this.users[index].password ||
          user.active != this.users[index].active ||
          user.admin != this.users[index].admin
        );
      });
      if (this.newUser.email.trim() != "" && this.newUser.password.trim() != "")
        updateUsers.push(this.newUser);
      console.log(updateUsers);
      formData.append("users", JSON.stringify(updateUsers));
      let returnedData = await axios({
        method: "POST",
        url: `https://app.brighton.com/brighton-your-day/api/admin/updateUsers`,
        responseType: "json",
        data: formData,
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      });
      if (returnedData.data.success) {
        this.userUpdateMsg = "Updated";
        this.users = JSON.parse(JSON.stringify(returnedData.data.users));
        this.usersTemp = JSON.parse(JSON.stringify(returnedData.data.users));
        this.newUser.email = "";
        this.newUser.password = "";
        this.newUser.active = 0;
        this.newUser.admin = 0;
      } else this.userUpdateMsg = "Update failed";
    },
    async logIn() {
      if (this.userName.trim() == "" || this.password.trim() == "") {
        this.error = "Username or/and password is required";
      } else {
        this.error = "Verifying ...";
        var formData = new FormData();
        formData.append("userName", this.userName);
        formData.append("password", this.password);
        let returnedData = await axios({
          method: "POST",
          url: `https://app.brighton.com/brighton-your-day/api/admin/login`,
          responseType: "json",
          data: formData,
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
          }
        });
        if (returnedData.data.success) {
          this.admin = returnedData.data.remark.admin;
          this.users = JSON.parse(JSON.stringify(returnedData.data.users));
          this.usersTemp = JSON.parse(JSON.stringify(returnedData.data.users));
          this.getAllSubmissions(0);
          this.getAllSubmissions(1);
          this.getAllSubmissions(-1);
          this.error = "Success!";
        } else {
          this.error = "Invalid username/password.  ";
        }
      }
    },
    selectTab(status) {
      this.selectedTab = status;
      this.$forceUpdate();
    },
    reload() {
      // modal saved...need to reload the submissions
      this.getAllSubmissions(0);
      this.getAllSubmissions(1);
      this.getAllSubmissions(-1);
      this.showModal = false;
    },
    selectSubmissionToEdit(submission) {
      this.selectedSubmission = submission;
      this.showModal = true;
    },
    async getAllSubmissions(status, pageNum = 0) {
      var formData = new FormData();
      formData.append("status", status);
      formData.append("pageNum", pageNum);
      formData.append("password", this.password);
      formData.append("userName", this.userName);
      formData.append("numPerPage", this.numPerPage);

      let returnedData = await axios({
        method: "POST",
        url: `https://app.brighton.com/brighton-your-day/api/admin/`,
        responseType: "json",
        data: formData,
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      });
      if (returnedData.data.success) {
        if (status == 0) {
          this.submissions.pending = {};
          this.submissions.pending.submissions = returnedData.data.submissions.filter(
            submission => submission.approved == 0
          );
          this.submissions.pending.numRows = returnedData.data.numRows;
        } else if (status == 1) {
          this.submissions.approved = {};
          this.submissions.approved.submissions = returnedData.data.submissions.filter(
            submission => submission.approved == 1
          );
          this.submissions.approved.numRows = returnedData.data.numRows;
        } else if (status == -1) {
          this.submissions.rejected = {};
          this.submissions.rejected.submissions = returnedData.data.submissions.filter(
            submission => submission.approved == -1
          );
          this.submissions.rejected.numRows = returnedData.data.numRows;
        }
        this.$forceUpdate();
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.admin {
  display: block;
  margin: 0 auto;
  text-align: left;
  #capLock {
    color: red;
  }
  ul {
    list-style: none;
    margin: 0px;
    padding: 0;
    li {
      display: inline-block;
      vertical-align: middle;
      padding: 5px;
      border: 1px solid #ccc;
      cursor: pointer;
      font-weight: bold;
    }
    li:hover,
    li.active {
      background-color: #ccc;
      color: #fff;
    }
  }

  table {
    border-collapse: collapse;
    border: 1px solid #ececec;
    tr {
      cursor: pointer;
      th,
      td {
        border: 1px solid #ececec;
        padding: 5px;
        img {
          width: 100px;
        }
      }
    }
    tr:hover {
      th,
      td {
        background-color: #ececec;
      }
    }

    tr.pagination {
      td {
        background-color: white;
        span {
          display: inline-block;
          padding: 5px 10px;
        }
        span {
          border: 1px solid #000;
          margin: 4px;
        }
        span:hover {
          color: red;
          background-color: #ebebeb;
        }
      }
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
